// Events
export var CLICK_PRIVACY_POLICY_LINK = 'CLICK_PRIVACY_POLICY_LINK';
export var UNDO_DISMISSAL_STARTED = 'UNDO_DISMISSAL_STARTED';
export var UNDO_DISMISSAL_SUCCEEDED = 'UNDO_DISMISSAL_SUCCEEDED';
export var UNDO_DISMISSAL_FAILED = 'UNDO_DISMISSAL_FAILED';

// Global Constants
export var CACHE_NAME = 'atlassian-growth-recos';